import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { useStorm } from '../../storm/StormContext';

// Runs only AFTER the entry is persisted. Proof-of-save first ("sealed"), then the storm
// surges by the current intensity (a long stormy entry seals harder), collapses, snaps to
// silence for a beat, and hands off to the archive.
const STAMP_MS = 900;
const SILENCE_MS = 400;

const SaveSequence: React.FC<{ active: boolean; intensity: number; onDone: () => void }> = ({ active, intensity, onDone }) => {
  const { surge, reducedMotion } = useStorm();
  useEffect(() => {
    if (!active) return;
    let alive = true;
    (async () => {
      await new Promise((r) => window.setTimeout(r, reducedMotion ? 500 : STAMP_MS));
      if (!alive) return;
      await surge(Math.min(1, 0.55 + intensity * 0.5));
      await new Promise((r) => window.setTimeout(r, reducedMotion ? 0 : SILENCE_MS));
      if (alive) onDone();
    })();
    return () => { alive = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active]);

  if (!active) return null;
  return (
    <div className="save-seq" role="status" aria-live="assertive">
      {/* Reduced motion: the stamp only fades in at rest (no scale/rotate spring). */}
      <motion.div className="save-stamp"
        initial={reducedMotion ? { opacity: 0, scale: 1, rotate: -6 } : { scale: 2.4, opacity: 0, rotate: -14 }}
        animate={{ scale: 1, opacity: 1, rotate: -6 }}
        transition={reducedMotion ? { duration: 0.3 } : { type: 'spring', stiffness: 380, damping: 18 }}>
        sealed
      </motion.div>
    </div>
  );
};

export default SaveSequence;
